import { FIQAssist } from "../app";
import { Component, Input, Output, Binding, Attribute, Inject, OutputArgs } from "@fiqas/angular-utils";
import { KeyCodes, KeyboardEventCode } from "@fiqas/utils";
import { TranslationService } from '../services/TranslationService';

@Component({
    module: FIQAssist,
    selector: 'inlineTextEditor',
    template: `<div class="display ng-class:{empty:$ctrl.empty, pointer:!$ctrl.readOnly}" ng-if="!$ctrl.editMode" ng-click="$ctrl.editMode=!$ctrl.readOnly"
                    tooltip-enable="!$ctrl.readOnly || $ctrl.getTitleOverflow" tooltip-apend-to-body="false" tooltip-placement="bottom" tooltip-class="{{$ctrl.getTooltipClass}}" tooltip-popup-delay="300" uib-tooltip="{{$ctrl.getTooltipText}}"
                    >
                    {{$ctrl.value}}
                </div>
                <div class="icon-container" style="height: 100%; cursor: pointer;" ng-if="!$ctrl.editMode && !$ctrl.readOnly" ng-click="$ctrl.editMode=true"
                    tooltip-append-to-body="true" tooltip-placement="bottom" tooltip-class="customTooltipTB" uib-tooltip="{{$ctrl.readOnly ? $ctrl.value : ('CLICK_TO_EDIT' | translate)}}">
                    <div class="icon icon-edit"></div>
                </div>

                </div>
                <span class="editor ng-class:{empty:$ctrl.empty}" ng-if="$ctrl.editMode">
                    <span class="hint unselectable" ng-show="$ctrl.emptyEdit">{{$ctrl.hint}}</span>
                    <input ng-keydown="$ctrl.onKey($event)" ng-keyup="$ctrl.onKeyUp($event)" class="inputEdit ng-class:{empty:$ctrl.emptyEdit}" size="{{($ctrl.value.length < 10) ? 10 : $ctrl.value.length}}" ng-model="$ctrl.editvalue" ng-focus="$ctrl.adjust()" ng-change="$ctrl.adjust()" ng-blur="$ctrl.onBlur($event)" />
                    <span class="icon icon-SAVE-CHECK ng-class:{'unselectable':$ctrl.emptyEdit}" ng-mousedown="$ctrl.actionClick = true" ng-click="$ctrl.commitEdit()"></span>
                    <span class="icon icon-Clear-Edit" ng-mousedown="$ctrl.actionClick = true" ng-click="$ctrl.cancelEdit()"></span>
                </span>`
})
export class InlineTextEditor {

    private actionClick: boolean = false;
    private keydown: boolean;
    private editvalue = '';
    private _editMode: boolean;

    private clickToEditText: string;
    public titleOverflow: boolean = false;
    public titleToolTipText: string;
    public titleToolTipClass: string = 'customTooltipTB';

    @Input() readOnly: boolean;
    @Input() public hint: string;

    private _value: string;
    @Input() public set value(val: string) {
        this.editvalue = this._value = val;
        //this.updateTooltipValue();
    }
    public get value() {
        return this._value;
    }

    @Output() public valueSubmit: (args: { value: string }) => void;
    @Output() public onValueChanged: OutputArgs<{ value: string }>;
    @Output() public editModeChanged: OutputArgs<{ value: boolean }>;

    constructor(
        @Inject("$element") private $element: ng.IRootElementService,
        @Inject("$timeout") private $timeout: ng.ITimeoutService,
        @Inject() private TranslationService: TranslationService,
        @Inject('$scope') private $scope: ng.IScope
    ) {

    }

    $onInit() {
        this.clickToEditText = this.TranslationService.Translate('CLICK_TO_EDIT');
    }

    public onBlur($event: JQueryEventObject) {
        if (!this.actionClick && !this.emptyEdit) {
            this.cancelEdit();
        }
        if (this.emptyEdit) {
            $event.preventDefault();
            this.$timeout(() => this.$element[0].getElementsByClassName('inputEdit')[0].focus(), 1);
        }
    }

    public commitEdit() {
        if (this.editvalue) {
            this.actionClick = false;
            this.editMode = false;
            if (this.value !== this.editvalue) {
                this.value = this.editvalue;
                this.onValueChanged({ value: this.editvalue });
            }
        }
    }

    public cancelEdit() {
        this.actionClick = false;
        this.editMode = false;
    }

    public get empty(): boolean {
        return !this.value || this.value.length == 0;
    }

    public get emptyEdit(): boolean {
        return !this.keydown && (!this.editvalue || this.editvalue.length == 0);
    }

    public set editMode(val: boolean) {
        const current = this._editMode;
        if (val && !this._editMode) {
            this.editvalue = this.value;
            this.$timeout(() => this.$element[0].getElementsByClassName('inputEdit')[0].focus(), 25);
        }
        this._editMode = val;
        if (current !== val) {
            this.editModeChanged({ value: val });
        }
    }

    public get editMode() {
        return this._editMode;
    }

    private async adjust() {
        const element = this.$element;
        const editor: HTMLInputElement = (<any>element[0].getElementsByClassName('inputEdit').item(0));
        editor.size = (editor.value.length < 10) ? 10 : editor.value.length;
    }

    private onKey($event: KeyboardEvent) {
        this.keydown = true;
        if ($event.keyCode === 0) {

            switch ($event.code) {
                case KeyboardEventCode.enter:
                    if (!this._value || this._value.length == 0) {
                        $event.preventDefault();
                    } else if (this.valueSubmit && !this.valueSubmit({ value: this._value }) || !this.valueSubmit) {
                        this.commitEdit()
                    }
                    break;
                case KeyboardEventCode.escape:
                    this.cancelEdit();
                    break;
            }
        } else {
            switch ($event.keyCode) {
                case KeyCodes.enter:
                    if (!this._value || this._value.length == 0) {
                        $event.preventDefault();
                    } else if (this.valueSubmit && !this.valueSubmit({ value: this._value }) || !this.valueSubmit) {
                        this.commitEdit()
                    }
                    break;

                case KeyCodes.escape:
                    this.cancelEdit();
                    break;
            }
        }
    }

    private onKeyUp($event: KeyboardEvent) {
        this.keydown = false;
    }

    private isTitleOverflow(el: any, titleText: string): boolean {
        const curOverflow = el.style.overflow;

        el.innerHTML = titleText;

        if (!curOverflow || curOverflow === "visible") {
            el.style.overflow = "hidden";
        }

        const titleOverflow = el.clientWidth < el.scrollWidth
            || el.clientHeight < el.scrollHeight;

        el.style.overflow = curOverflow;
        return titleOverflow;
    }

    public get getTitleOverflow(): boolean {
        this.titleOverflow = true;

        const displayElement = this.$element[0].getElementsByClassName('display').item(0);

        if (displayElement && this.value) {
            this.titleOverflow = this.isTitleOverflow(displayElement, this.value);
        }
        return this.titleOverflow;
    }

    public get getTooltipText() {
        const displayElement = this.$element[0].getElementsByClassName('display').item(0);

        if (displayElement && this.value) {

            if (this.isTitleOverflow(displayElement, this.value)) {
                this.titleToolTipText = this.value;
                if (!this.readOnly) {
                    return `${this.titleToolTipText}\r\n(${this.clickToEditText})`;
                } else {
                    return this.titleToolTipText;
                }
            } else {
                return this.clickToEditText;
            }
        }
    }

    public get getTooltipClass() {
        const displayElement = this.$element[0].getElementsByClassName('display').item(0);

        this.titleToolTipClass = 'customTooltipTB';
        if (displayElement && this.value) {
            if (this.isTitleOverflow(displayElement, this.value)) {
                this.titleToolTipClass = 'customTooltipDesc';
            } else {
                this.titleToolTipClass = 'customTooltipTB';
            }
        }
        return this.titleToolTipClass;
    }
}
